import { IPaging } from "./http.model";

export interface IGetNotifyParams extends IPaging {
  q?: string;
}

export enum NotificationTypeEnum {
  HOMEWORKASSIGNED = 'HOMEWORKASSIGNED',
  HOMEWORKCONFIRMED = 'HOMEWORKCONFIRMED',
  HOMEWORKREJECTED = 'HOMEWORKREJECTED',
  HOMEWORKANSWERED = 'HOMEWORKANSWERED',
  COURSENEW = 'COURSENEW',
  COURSESTARTED = 'COURSESTARTED',
  SYSTEM = 'SYSTEM'
}

export const NotifyMapper = {
  HOMEWORKASSIGNED: 'notify.homeworkAssigned',
  HOMEWORKCONFIRMED: 'notify.homeworkConfirmed',
  HOMEWORKREJECTED: 'notify.homeworkRejected',
  HOMEWORKANSWERED: 'notify.homeworkAnswer',
  COURSENEW: 'notify.courseNew',
  COURSESTARTED: 'notify.courseStarted',
  SYSTEM: ''
}

export const NotifyIconMapper = {
  HOMEWORKASSIGNED: 'solution',
  HOMEWORKCONFIRMED: 'solution',
  HOMEWORKREJECTED: 'solution',
  HOMEWORKANSWERED: 'solution',
  COURSENEW: 'solution',
  COURSESTARTED: 'solution',
  SYSTEM: 'solution',
}

export interface INotifyItem {
  createdAt: string;
  data: any;
  id: string;
  seen: boolean;
  type: NotificationTypeEnum;
  updatedAt: string;
  userId: string;
  actor: string;
  message: string;
  notifyIcon: string;
  body?: string;
  title?: string;
}

export interface INotify {
  items: INotifyItem[];
  lastSeen: string;
  total: number;
  totalNew: number;
}
